import { ReactNode } from 'react';

/** The small grey count beside a drawer tab's label. */
const CountBox = ({ children }: { children: ReactNode }) => (
    <span className="bg-grey-200 flex h-4 w-fit items-center rounded-[4px] px-1 text-[10px] leading-none font-semibold">
        {children}
    </span>
);

export default CountBox;
